export const MANAGEMENT_ERRORS_CODES = {
  BUSS_0022: 'BUSS_0022',
  VAL_0002: 'VAL_0002',
}
